export default "__VITE_ASSET__oxnWeIOU__"